import { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLeadershipWheelStore } from '../store/useLeadershipWheelStore';

export function useLeadershipWheel() {
  const { leadershipWheelPage, onInit, onResetAllAnswers } = useLeadershipWheelStore();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    onInit();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onResetAllAnswers();
  }, [onResetAllAnswers]);

  return {
    navigate,
    leadershipWheelPage,
  };
}
